/* tslint:disable */
export var SessionType;
(function (SessionType) {
    SessionType[SessionType["UNKNOWN"] = 0] = "UNKNOWN";
    SessionType[SessionType["FIRST_SESSION"] = 1] = "FIRST_SESSION";
    SessionType[SessionType["FIRST_SESSION_AFTER_UPDATE"] = 2] = "FIRST_SESSION_AFTER_UPDATE";
    SessionType[SessionType["REGULAR_SESSION"] = 3] = "REGULAR_SESSION";
})(SessionType || (SessionType = {}));
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/SessionTypeEnum.ts
// module id = 800
// module chunks = 3